<template>
    <component
        :is="to ? 'router-link' : 'button'"
        v-bind="
            to
                ? { to, 'aria-current': active ? 'page' : undefined }
                : { type: 'button', 'aria-pressed': active }
        "
        :class="[active ? selected : unselected]"
        class="cursor-pointer whitespace-nowrap px-3 py-1.5 text-sm font-medium transition-colors rounded-full inline-flex items-center justify-center text-center"
    >
        <slot />
    </component>
</template>

<script>
export default {
    name: 'ZenTab',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        to: {
            type: [String, Object],
            default: null,
        },
    },
    computed: {
        selected() {
            return 'text-white bg-sky-500'
        },
        unselected() {
            return 'text-sky-500 hover:text-sky-900 hover:bg-sky-200'
        },
    },
}
</script>
